module.exports = __webpack_public_path__ + "static/media/filled_bar_packShip_tall.96c206ee.svg";